import { grey, secondary } from 'assets/colors/colors';

export const helpOptionCardStyles = {
  border: `1px solid ${grey.g200}`,
  borderRadius: 2,
  padding: 2,
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  width: '200px',
  '&:hover': {
    border: `2px solid ${secondary.main}`,
    cursor: 'pointer',
    backgroundColor: secondary.background,
  },
};
